// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Yzw4","selected":"Chip_selected__1Eu4H"};